import { createAction } from '@reduxjs/toolkit';

export const SHOW_MESSAGE = 'message/SHOW';
export const HIDE_MESSAGE = 'message/HIDE';

export const showMessage = createAction(SHOW_MESSAGE, (type: string, props?: any) => ({
  payload: { type, props },
}));
export const hideMessage = createAction(HIDE_MESSAGE);
